import { isNullOrUndefined } from 'util';
import { parseUser } from './parseUser';
import { getInjectorLegacy } from '../components/injectorProvider';
import { OAuthService } from 'angular-oauth2-oidc';

function getAuthHeaders() {
  return new Promise((resolve, reject) => {
    setTimeout(function () {
      const accessToken = getAccessToken();
      !isNullOrUndefined(accessToken)
        ? resolve({
          Authorization: `Bearer ${accessToken}`,
        })
        : reject('Error');
    }, 2000);
  });
}

function isLoggedIn() {
  const token = getAccessToken();
  return token !== null || token !== undefined;
}

function getAccessToken() {
  return getOAuthService().getAccessToken();
}

function getLoginData() {
  const claims = getOAuthService().getIdentityClaims();

    if (claims === null)
      return null;

  return parseUser(claims);
}

function getOAuthService() {
  const injector = getInjectorLegacy();
  const oauthService = injector.get(OAuthService);

  if(!oauthService) {
    throw Error("Could not get OAuthService");
  }

  return oauthService;
}

export {
  getAuthHeaders,
  getLoginData,
  isLoggedIn
};